<script>
  import FormInput from '../FormControls/FormInput.svelte';
  import FormTextarea from '../FormControls/FormTextarea.svelte';
  import { configItem, searchKeyByValue } from 'components/Helper.js';
  export let form;
  export let errors;
  export let handleChange;
  import { onDestroy } from 'svelte';
  import { masterData, getMasterData } from '../../stores/masterData.js';
  import Select from 'svelte-select';

  let otherObj = { id: '', name: 'Other' };
  // let serviceProviderTypes=[]
  // const masterUnitUnsubscribe = masterData.subscribe(state => {
  //     if(state!=undefined){
  //         serviceProviderTypes = [...state.serviceProviderTypes];
  //         serviceProviderTypes.push(otherObj)
  //       }
  // });
  export let serviceProviderTypes = [];
  // onDestroy(() => {
  //    masterUnitUnsubscribe();
  // });

  function addProvider() {
    let arr = $form.serviceProviders;
    arr.push({
      new: 1,
      name: '',
      type: '',
      email: '',
      phone: '',
      serviceProviderTypeId: null,
      notes: '',
      serviceProviderTypeName: undefined,
    });
    $form.serviceProviders = arr;
  }

  $: if ($form.serviceProviders.length == 0) {
    addProvider();
  }

  for (const i in $form.serviceProviders) {
    if ($form.serviceProviders[i].serviceProviderTypeId == null) {
      $form.serviceProviders[i].serviceProviderTypeId = '';
      $form.serviceProviders[i].serviceProviderTypeName = otherObj;
    } else {
      $form.serviceProviders[i].serviceProviderTypeName =
        serviceProviderTypes[
          searchKeyByValue(
            serviceProviderTypes,
            'id',
            $form.serviceProviders[i].serviceProviderTypeId,
          )
        ];
    }
  }

  const removeProvider = (key) => {
    let arr = $form.serviceProviders;
    arr.splice(key, 1);
    $form.serviceProviders = arr;

    let errorArr = $errors.serviceProviders;
    errorArr.splice(key, 1);
    $errors.serviceProviders = errorArr;
  };
</script>

<div class="p-3 h-100 font-size-12">
  <div class="profile-content mx-auto">
    <div class="block-title mb-4">
      <h3 class="mt-0 title"><span>Service Provider Contacts</span></h3>
    </div>
  </div>
  <div class="profile-content mx-auto h-100">
    <div class="row">
      <div class="col">
        {#each $form.serviceProviders as item, i}
          <div class="row">
            <div class="col-md-6">
              <FormInput
                name={`serviceProviders[${i}].name`}
                label="Service Provider Name(s)"
                placeholder="Name"
                error={$errors.serviceProviders[i] != undefined
                  ? $errors.serviceProviders[i].name
                  : undefined}
                bind:value={$form.serviceProviders[i].name}
                handleChange={handleChange}
              />
            </div>

            <div class="col-md-3">
              <FormInput
                name={`serviceProviders[${i}].phone`}
                label="Phone No."
                placeholder="Phone No."
                error={$errors.serviceProviders[i] != undefined
                  ? $errors.serviceProviders[i].phone
                  : undefined}
                bind:value={$form.serviceProviders[i].phone}
                handleChange={handleChange}
              />
            </div>
            <div class="col-md-3">
              <div class="form-group mb-3">
                <FormInput
                  name={`serviceProviders[${i}].email`}
                  type="email"
                  label="Email"
                  placeholder="Email"
                  error={$errors.serviceProviders[i] != undefined
                    ? $errors.serviceProviders[i].email
                    : undefined}
                  bind:value={$form.serviceProviders[i].email}
                  handleChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="form-group mb-3 select-block">
                <label
                  for="serviceProviders[{i}].type"
                  class="form-label undefined"
                  >Type
                </label>
                <Select
                  bind:selectedValue={$form.serviceProviders[i].serviceProviderTypeName}
                  showChevron={true}
                  isClearable={false}
                  items={serviceProviderTypes}
                  getSelectionLabel={(option) => {
                    return option.name;
                  }}
                  on:select={(ev) => {
                    $form.serviceProviders[i].serviceProviderTypeId = ev.detail.id;
                    if ($form.serviceProviders[i].type != '') {
                      $form.serviceProviders[i].type = '';
                    }
                  }}
                  optionIdentifier="id"
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                  placeholder="Type"
                />
              </div>
            </div>
            <div class="col-md-8">
              {#if $form.serviceProviders[i].serviceProviderTypeId != undefined && $form.serviceProviders[i].serviceProviderTypeId == ''}
                <div class="form-group mb-3 select-block">
                  <FormInput
                    label="Other"
                    maxLength={configItem.maxLength.input}
                    name={`serviceProviders[${i}].type`}
                    placeholder="Other Type "
                    error={$errors.serviceProviders[i] != undefined
                      ? $errors.serviceProviders[i].type
                      : undefined}
                    bind:value={$form.serviceProviders[i].type}
                    handleChange={handleChange}
                  />
                </div>
              {/if}
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-3">
                <FormTextarea
                  label="Notes"
                  bind:value={$form.serviceProviders[i].notes}
                  placeholder="Enter Notes"
                />
              </div>
            </div>
          </div>
          {#if i === 0}
            <hr />
            <div class="d-flex justify-content-end mb-2 flex-column align-items-end">
              {#if $form.serviceProviders.length == 1 && $form.serviceProviders[i].new == undefined}
                <button
                  class="btn btn-link px-0 mb-0 box-shadow-none border-0 bg-transparent font-size-12 color-red shadow-none"
                  on:click={() => removeProvider(i)}
                >
                  <img
                    alt=""
                    class="icon-16 me-1"
                    src="/images/trash.svg"
                  /> Clear
                </button>
              {/if}
              <button
                on:click={() => addProvider()}
                class="btn btn-link px-0 mb-0 bg-transparent box-shadow-none border-0 font-size-12 shadow-none"
              >
                <img
                  class="icon-10"
                  alt=""
                  src="/images/plus.svg"
                /> Add More</button
              >
            </div>
          {:else}
            <div class="d-flex justify-content-end mb-2">
              <button
                on:click={() => removeProvider(i)}
                class="btn btn-link px-0 mb-0 box-shadow-none border-0 bg-transparent font-size-12 color-red shadow-none"
              >
                <img
                  alt=""
                  class="icon-16 me-1"
                  src="/images/trash.svg"
                /> Remove</button
              >
            </div>
          {/if}
        {/each}
      </div>
    </div>
  </div>
</div>
